/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CandidateMotivationalTexts,
  Document,
  DocumentResponse,
  DocumentResponseBase,
  FileResponseBase64,
  UploadTypes,
} from '../models/index';
import {
    CandidateMotivationalTextsFromJSON,
    CandidateMotivationalTextsToJSON,
    DocumentFromJSON,
    DocumentToJSON,
    DocumentResponseFromJSON,
    DocumentResponseToJSON,
    DocumentResponseBaseFromJSON,
    DocumentResponseBaseToJSON,
    FileResponseBase64FromJSON,
    FileResponseBase64ToJSON,
    UploadTypesFromJSON,
    UploadTypesToJSON,
} from '../models/index';

export interface DeleteFileRequest {
    fileId?: string;
}

export interface DownloadFileRequest {
    documentId?: string;
    siteKey?: string;
}

export interface DownloadFileAsBase64Request {
    documentId?: string;
    siteKey?: string;
}

export interface GetCVRequest {
    langCode?: string;
    mediaId?: number;
    colorNodeId?: number;
    profileNodeId?: number;
    helptextNodeId?: number;
    exclusionsProfessionalCompetences?: Array<number>;
    exclusionsPersonalCompetences?: Array<number>;
    exclusionsLanguages?: Array<number>;
    exclusionsItSkills?: Array<number>;
    exclusionsLicenses?: Array<number>;
    exclusionsWorkExperiences?: Array<number>;
    exclusionsEducations?: Array<number>;
    exclusionsCourses?: Array<number>;
    exclusionsVolunteerWork?: Array<number>;
    exclusionsJobTypes?: Array<number>;
    exclusionsJobGoals?: Array<number>;
    exclusionsJobFunctions?: Array<number>;
    useMotivationalTexts?: boolean;
    motivationalHeadline?: string;
    motivationalText?: string;
    pdf?: boolean;
}

export interface GetCVPageCountRequest {
    langCode?: string;
    mediaId?: number;
    profileNodeId?: number;
    isTemplate?: boolean;
    helptextNodeId?: number;
    exclusionsProfessionalCompetences?: Array<number>;
    exclusionsPersonalCompetences?: Array<number>;
    exclusionsLanguages?: Array<number>;
    exclusionsItSkills?: Array<number>;
    exclusionsLicenses?: Array<number>;
    exclusionsWorkExperiences?: Array<number>;
    exclusionsEducations?: Array<number>;
    exclusionsCourses?: Array<number>;
    exclusionsVolunteerWork?: Array<number>;
    exclusionsJobTypes?: Array<number>;
    exclusionsJobGoals?: Array<number>;
    exclusionsJobFunctions?: Array<number>;
    useMotivationalTexts?: boolean;
    motivationalHeadline?: string;
    motivationalText?: string;
}

export interface GetCVPreviewRequest {
    pageNumber?: number;
    langCode?: string;
    mediaId?: number;
    colorNodeId?: number;
    profileNodeId?: number;
    isTemplate?: boolean;
    helptextNodeId?: number;
    exclusionsProfessionalCompetences?: Array<number>;
    exclusionsPersonalCompetences?: Array<number>;
    exclusionsLanguages?: Array<number>;
    exclusionsItSkills?: Array<number>;
    exclusionsLicenses?: Array<number>;
    exclusionsWorkExperiences?: Array<number>;
    exclusionsEducations?: Array<number>;
    exclusionsCourses?: Array<number>;
    exclusionsVolunteerWork?: Array<number>;
    exclusionsJobTypes?: Array<number>;
    exclusionsJobGoals?: Array<number>;
    exclusionsJobFunctions?: Array<number>;
    useMotivationalTexts?: boolean;
    motivationalHeadline?: string;
    motivationalText?: string;
}

export interface GetCVSectionsRequest {
    mediaId?: number;
}

export interface GetCoverLetterRequest {
    langCode?: string;
    mediaId?: number;
    colorNodeId?: number;
}

export interface GetDocumentsByTypeRequest {
    type?: string;
}

export interface GetExampleCVRequest {
    mediaId?: number;
    pdf?: boolean;
}

export interface GetMissingProfileSectionsRequest {
    mediaId?: number;
    professionalCompetences?: Array<number>;
    personalCompetences?: Array<number>;
    languages?: Array<number>;
    itSkills?: Array<number>;
    licenses?: Array<number>;
    workExperiences?: Array<number>;
    educations?: Array<number>;
    courses?: Array<number>;
    volunteerWork?: Array<number>;
    jobTypes?: Array<number>;
    jobGoals?: Array<number>;
    jobFunctions?: Array<number>;
}

export interface PublicFileRequest {
    type?: string;
}

export interface ResetPublicRequest {
    documentId?: string;
    documentType?: string;
}

export interface SaveCVToDocumentsRequest {
    langCode?: string;
    mediaId?: number;
    colorNodeId?: number;
    profileNodeId?: number;
    exampleName?: string;
    helptextNodeId?: number;
    exclusionsProfessionalCompetences?: Array<number>;
    exclusionsPersonalCompetences?: Array<number>;
    exclusionsLanguages?: Array<number>;
    exclusionsItSkills?: Array<number>;
    exclusionsLicenses?: Array<number>;
    exclusionsWorkExperiences?: Array<number>;
    exclusionsEducations?: Array<number>;
    exclusionsCourses?: Array<number>;
    exclusionsVolunteerWork?: Array<number>;
    exclusionsJobTypes?: Array<number>;
    exclusionsJobGoals?: Array<number>;
    exclusionsJobFunctions?: Array<number>;
    useMotivationalTexts?: boolean;
    motivationalHeadline?: string;
    motivationalText?: string;
    pdf?: boolean;
}

export interface SaveCoverLetterToDocumentsRequest {
    langCode?: string;
    mediaId?: number;
    colorNodeId?: number;
    exampleName?: string;
}

export interface SaveMotivationalTextRequest {
    body?: any | null;
}

export interface SetPublicRequest {
    documentId?: string;
    documentType?: string;
    programmeId?: string;
    name?: string;
}

export interface UpdateFileDataRequest {
    body?: any | null;
}

export interface UploadDocumentsRequest {
    contentType?: string;
    fileName?: string;
    documentType?: string;
    uploadTypes?: UploadTypes;
    body?: string;
}

/**
 * 
 */
export class DocumentApi extends runtime.BaseAPI {

    /**
     */
    async deleteFileRaw(requestParameters: DeleteFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponse>> {
        const queryParameters: any = {};

        if (requestParameters.fileId !== undefined) {
            queryParameters['fileId'] = requestParameters.fileId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/DeleteFile`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentResponseFromJSON(jsonValue));
    }

    /**
     */
    async deleteFile(requestParameters: DeleteFileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponse> {
        const response = await this.deleteFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async downloadFileRaw(requestParameters: DownloadFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.documentId !== undefined) {
            queryParameters['documentId'] = requestParameters.documentId;
        }

        if (requestParameters.siteKey !== undefined) {
            queryParameters['siteKey'] = requestParameters.siteKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/DownloadFile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async downloadFile(requestParameters: DownloadFileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.downloadFileRaw(requestParameters, initOverrides);
    }

    /**
     */
    async downloadFileAsBase64Raw(requestParameters: DownloadFileAsBase64Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileResponseBase64>> {
        const queryParameters: any = {};

        if (requestParameters.documentId !== undefined) {
            queryParameters['documentId'] = requestParameters.documentId;
        }

        if (requestParameters.siteKey !== undefined) {
            queryParameters['siteKey'] = requestParameters.siteKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/DownloadFileAsBase64`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileResponseBase64FromJSON(jsonValue));
    }

    /**
     */
    async downloadFileAsBase64(requestParameters: DownloadFileAsBase64Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileResponseBase64> {
        const response = await this.downloadFileAsBase64Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCVRaw(requestParameters: GetCVRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.langCode !== undefined) {
            queryParameters['langCode'] = requestParameters.langCode;
        }

        if (requestParameters.mediaId !== undefined) {
            queryParameters['mediaId'] = requestParameters.mediaId;
        }

        if (requestParameters.colorNodeId !== undefined) {
            queryParameters['colorNodeId'] = requestParameters.colorNodeId;
        }

        if (requestParameters.profileNodeId !== undefined) {
            queryParameters['profileNodeId'] = requestParameters.profileNodeId;
        }

        if (requestParameters.helptextNodeId !== undefined) {
            queryParameters['HelptextNodeId'] = requestParameters.helptextNodeId;
        }

        if (requestParameters.exclusionsProfessionalCompetences) {
            queryParameters['Exclusions.ProfessionalCompetences'] = requestParameters.exclusionsProfessionalCompetences;
        }

        if (requestParameters.exclusionsPersonalCompetences) {
            queryParameters['Exclusions.PersonalCompetences'] = requestParameters.exclusionsPersonalCompetences;
        }

        if (requestParameters.exclusionsLanguages) {
            queryParameters['Exclusions.Languages'] = requestParameters.exclusionsLanguages;
        }

        if (requestParameters.exclusionsItSkills) {
            queryParameters['Exclusions.ItSkills'] = requestParameters.exclusionsItSkills;
        }

        if (requestParameters.exclusionsLicenses) {
            queryParameters['Exclusions.Licenses'] = requestParameters.exclusionsLicenses;
        }

        if (requestParameters.exclusionsWorkExperiences) {
            queryParameters['Exclusions.WorkExperiences'] = requestParameters.exclusionsWorkExperiences;
        }

        if (requestParameters.exclusionsEducations) {
            queryParameters['Exclusions.Educations'] = requestParameters.exclusionsEducations;
        }

        if (requestParameters.exclusionsCourses) {
            queryParameters['Exclusions.Courses'] = requestParameters.exclusionsCourses;
        }

        if (requestParameters.exclusionsVolunteerWork) {
            queryParameters['Exclusions.VolunteerWork'] = requestParameters.exclusionsVolunteerWork;
        }

        if (requestParameters.exclusionsJobTypes) {
            queryParameters['Exclusions.JobTypes'] = requestParameters.exclusionsJobTypes;
        }

        if (requestParameters.exclusionsJobGoals) {
            queryParameters['Exclusions.JobGoals'] = requestParameters.exclusionsJobGoals;
        }

        if (requestParameters.exclusionsJobFunctions) {
            queryParameters['Exclusions.JobFunctions'] = requestParameters.exclusionsJobFunctions;
        }

        if (requestParameters.useMotivationalTexts !== undefined) {
            queryParameters['UseMotivationalTexts'] = requestParameters.useMotivationalTexts;
        }

        if (requestParameters.motivationalHeadline !== undefined) {
            queryParameters['MotivationalHeadline'] = requestParameters.motivationalHeadline;
        }

        if (requestParameters.motivationalText !== undefined) {
            queryParameters['MotivationalText'] = requestParameters.motivationalText;
        }

        if (requestParameters.pdf !== undefined) {
            queryParameters['pdf'] = requestParameters.pdf;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/GetCV`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getCV(requestParameters: GetCVRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCVRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getCVPageCountRaw(requestParameters: GetCVPageCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters.langCode !== undefined) {
            queryParameters['langCode'] = requestParameters.langCode;
        }

        if (requestParameters.mediaId !== undefined) {
            queryParameters['mediaId'] = requestParameters.mediaId;
        }

        if (requestParameters.profileNodeId !== undefined) {
            queryParameters['profileNodeId'] = requestParameters.profileNodeId;
        }

        if (requestParameters.isTemplate !== undefined) {
            queryParameters['isTemplate'] = requestParameters.isTemplate;
        }

        if (requestParameters.helptextNodeId !== undefined) {
            queryParameters['HelptextNodeId'] = requestParameters.helptextNodeId;
        }

        if (requestParameters.exclusionsProfessionalCompetences) {
            queryParameters['Exclusions.ProfessionalCompetences'] = requestParameters.exclusionsProfessionalCompetences;
        }

        if (requestParameters.exclusionsPersonalCompetences) {
            queryParameters['Exclusions.PersonalCompetences'] = requestParameters.exclusionsPersonalCompetences;
        }

        if (requestParameters.exclusionsLanguages) {
            queryParameters['Exclusions.Languages'] = requestParameters.exclusionsLanguages;
        }

        if (requestParameters.exclusionsItSkills) {
            queryParameters['Exclusions.ItSkills'] = requestParameters.exclusionsItSkills;
        }

        if (requestParameters.exclusionsLicenses) {
            queryParameters['Exclusions.Licenses'] = requestParameters.exclusionsLicenses;
        }

        if (requestParameters.exclusionsWorkExperiences) {
            queryParameters['Exclusions.WorkExperiences'] = requestParameters.exclusionsWorkExperiences;
        }

        if (requestParameters.exclusionsEducations) {
            queryParameters['Exclusions.Educations'] = requestParameters.exclusionsEducations;
        }

        if (requestParameters.exclusionsCourses) {
            queryParameters['Exclusions.Courses'] = requestParameters.exclusionsCourses;
        }

        if (requestParameters.exclusionsVolunteerWork) {
            queryParameters['Exclusions.VolunteerWork'] = requestParameters.exclusionsVolunteerWork;
        }

        if (requestParameters.exclusionsJobTypes) {
            queryParameters['Exclusions.JobTypes'] = requestParameters.exclusionsJobTypes;
        }

        if (requestParameters.exclusionsJobGoals) {
            queryParameters['Exclusions.JobGoals'] = requestParameters.exclusionsJobGoals;
        }

        if (requestParameters.exclusionsJobFunctions) {
            queryParameters['Exclusions.JobFunctions'] = requestParameters.exclusionsJobFunctions;
        }

        if (requestParameters.useMotivationalTexts !== undefined) {
            queryParameters['UseMotivationalTexts'] = requestParameters.useMotivationalTexts;
        }

        if (requestParameters.motivationalHeadline !== undefined) {
            queryParameters['MotivationalHeadline'] = requestParameters.motivationalHeadline;
        }

        if (requestParameters.motivationalText !== undefined) {
            queryParameters['MotivationalText'] = requestParameters.motivationalText;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/GetCVPageCount`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getCVPageCount(requestParameters: GetCVPageCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getCVPageCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCVPreviewRaw(requestParameters: GetCVPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber;
        }

        if (requestParameters.langCode !== undefined) {
            queryParameters['langCode'] = requestParameters.langCode;
        }

        if (requestParameters.mediaId !== undefined) {
            queryParameters['mediaId'] = requestParameters.mediaId;
        }

        if (requestParameters.colorNodeId !== undefined) {
            queryParameters['colorNodeId'] = requestParameters.colorNodeId;
        }

        if (requestParameters.profileNodeId !== undefined) {
            queryParameters['profileNodeId'] = requestParameters.profileNodeId;
        }

        if (requestParameters.isTemplate !== undefined) {
            queryParameters['isTemplate'] = requestParameters.isTemplate;
        }

        if (requestParameters.helptextNodeId !== undefined) {
            queryParameters['HelptextNodeId'] = requestParameters.helptextNodeId;
        }

        if (requestParameters.exclusionsProfessionalCompetences) {
            queryParameters['Exclusions.ProfessionalCompetences'] = requestParameters.exclusionsProfessionalCompetences;
        }

        if (requestParameters.exclusionsPersonalCompetences) {
            queryParameters['Exclusions.PersonalCompetences'] = requestParameters.exclusionsPersonalCompetences;
        }

        if (requestParameters.exclusionsLanguages) {
            queryParameters['Exclusions.Languages'] = requestParameters.exclusionsLanguages;
        }

        if (requestParameters.exclusionsItSkills) {
            queryParameters['Exclusions.ItSkills'] = requestParameters.exclusionsItSkills;
        }

        if (requestParameters.exclusionsLicenses) {
            queryParameters['Exclusions.Licenses'] = requestParameters.exclusionsLicenses;
        }

        if (requestParameters.exclusionsWorkExperiences) {
            queryParameters['Exclusions.WorkExperiences'] = requestParameters.exclusionsWorkExperiences;
        }

        if (requestParameters.exclusionsEducations) {
            queryParameters['Exclusions.Educations'] = requestParameters.exclusionsEducations;
        }

        if (requestParameters.exclusionsCourses) {
            queryParameters['Exclusions.Courses'] = requestParameters.exclusionsCourses;
        }

        if (requestParameters.exclusionsVolunteerWork) {
            queryParameters['Exclusions.VolunteerWork'] = requestParameters.exclusionsVolunteerWork;
        }

        if (requestParameters.exclusionsJobTypes) {
            queryParameters['Exclusions.JobTypes'] = requestParameters.exclusionsJobTypes;
        }

        if (requestParameters.exclusionsJobGoals) {
            queryParameters['Exclusions.JobGoals'] = requestParameters.exclusionsJobGoals;
        }

        if (requestParameters.exclusionsJobFunctions) {
            queryParameters['Exclusions.JobFunctions'] = requestParameters.exclusionsJobFunctions;
        }

        if (requestParameters.useMotivationalTexts !== undefined) {
            queryParameters['UseMotivationalTexts'] = requestParameters.useMotivationalTexts;
        }

        if (requestParameters.motivationalHeadline !== undefined) {
            queryParameters['MotivationalHeadline'] = requestParameters.motivationalHeadline;
        }

        if (requestParameters.motivationalText !== undefined) {
            queryParameters['MotivationalText'] = requestParameters.motivationalText;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/GetCVPreview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getCVPreview(requestParameters: GetCVPreviewRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCVPreviewRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getCVSectionsRaw(requestParameters: GetCVSectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        if (requestParameters.mediaId !== undefined) {
            queryParameters['mediaId'] = requestParameters.mediaId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/GetCVSections`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getCVSections(requestParameters: GetCVSectionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getCVSectionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCoverLetterRaw(requestParameters: GetCoverLetterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.langCode !== undefined) {
            queryParameters['langCode'] = requestParameters.langCode;
        }

        if (requestParameters.mediaId !== undefined) {
            queryParameters['mediaId'] = requestParameters.mediaId;
        }

        if (requestParameters.colorNodeId !== undefined) {
            queryParameters['colorNodeId'] = requestParameters.colorNodeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/GetCoverLetter`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getCoverLetter(requestParameters: GetCoverLetterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCoverLetterRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getDocumentsByTypeRaw(requestParameters: GetDocumentsByTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Document>>> {
        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/GetDocumentsByType`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentFromJSON));
    }

    /**
     */
    async getDocumentsByType(requestParameters: GetDocumentsByTypeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Document>> {
        const response = await this.getDocumentsByTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getExampleCVRaw(requestParameters: GetExampleCVRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.mediaId !== undefined) {
            queryParameters['mediaId'] = requestParameters.mediaId;
        }

        if (requestParameters.pdf !== undefined) {
            queryParameters['pdf'] = requestParameters.pdf;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/GetExampleCV`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getExampleCV(requestParameters: GetExampleCVRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getExampleCVRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getMissingProfileSectionsRaw(requestParameters: GetMissingProfileSectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        if (requestParameters.mediaId !== undefined) {
            queryParameters['mediaId'] = requestParameters.mediaId;
        }

        if (requestParameters.professionalCompetences) {
            queryParameters['ProfessionalCompetences'] = requestParameters.professionalCompetences;
        }

        if (requestParameters.personalCompetences) {
            queryParameters['PersonalCompetences'] = requestParameters.personalCompetences;
        }

        if (requestParameters.languages) {
            queryParameters['Languages'] = requestParameters.languages;
        }

        if (requestParameters.itSkills) {
            queryParameters['ItSkills'] = requestParameters.itSkills;
        }

        if (requestParameters.licenses) {
            queryParameters['Licenses'] = requestParameters.licenses;
        }

        if (requestParameters.workExperiences) {
            queryParameters['WorkExperiences'] = requestParameters.workExperiences;
        }

        if (requestParameters.educations) {
            queryParameters['Educations'] = requestParameters.educations;
        }

        if (requestParameters.courses) {
            queryParameters['Courses'] = requestParameters.courses;
        }

        if (requestParameters.volunteerWork) {
            queryParameters['VolunteerWork'] = requestParameters.volunteerWork;
        }

        if (requestParameters.jobTypes) {
            queryParameters['JobTypes'] = requestParameters.jobTypes;
        }

        if (requestParameters.jobGoals) {
            queryParameters['JobGoals'] = requestParameters.jobGoals;
        }

        if (requestParameters.jobFunctions) {
            queryParameters['JobFunctions'] = requestParameters.jobFunctions;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/GetMissingProfileSections`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getMissingProfileSections(requestParameters: GetMissingProfileSectionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getMissingProfileSectionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMotivationalTextRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CandidateMotivationalTexts>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/GetMotivationalText`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CandidateMotivationalTextsFromJSON(jsonValue));
    }

    /**
     */
    async getMotivationalText(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CandidateMotivationalTexts> {
        const response = await this.getMotivationalTextRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async listRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/List`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentResponseFromJSON(jsonValue));
    }

    /**
     */
    async list(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponse> {
        const response = await this.listRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async publicFileRaw(requestParameters: PublicFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Document>> {
        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/PublicFile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFromJSON(jsonValue));
    }

    /**
     */
    async publicFile(requestParameters: PublicFileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Document> {
        const response = await this.publicFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async resetPublicRaw(requestParameters: ResetPublicRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.documentId !== undefined) {
            queryParameters['documentId'] = requestParameters.documentId;
        }

        if (requestParameters.documentType !== undefined) {
            queryParameters['documentType'] = requestParameters.documentType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/ResetPublic`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async resetPublic(requestParameters: ResetPublicRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.resetPublicRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveCVToDocumentsRaw(requestParameters: SaveCVToDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponseBase>> {
        const queryParameters: any = {};

        if (requestParameters.langCode !== undefined) {
            queryParameters['langCode'] = requestParameters.langCode;
        }

        if (requestParameters.mediaId !== undefined) {
            queryParameters['mediaId'] = requestParameters.mediaId;
        }

        if (requestParameters.colorNodeId !== undefined) {
            queryParameters['colorNodeId'] = requestParameters.colorNodeId;
        }

        if (requestParameters.profileNodeId !== undefined) {
            queryParameters['profileNodeId'] = requestParameters.profileNodeId;
        }

        if (requestParameters.exampleName !== undefined) {
            queryParameters['exampleName'] = requestParameters.exampleName;
        }

        if (requestParameters.helptextNodeId !== undefined) {
            queryParameters['HelptextNodeId'] = requestParameters.helptextNodeId;
        }

        if (requestParameters.exclusionsProfessionalCompetences) {
            queryParameters['Exclusions.ProfessionalCompetences'] = requestParameters.exclusionsProfessionalCompetences;
        }

        if (requestParameters.exclusionsPersonalCompetences) {
            queryParameters['Exclusions.PersonalCompetences'] = requestParameters.exclusionsPersonalCompetences;
        }

        if (requestParameters.exclusionsLanguages) {
            queryParameters['Exclusions.Languages'] = requestParameters.exclusionsLanguages;
        }

        if (requestParameters.exclusionsItSkills) {
            queryParameters['Exclusions.ItSkills'] = requestParameters.exclusionsItSkills;
        }

        if (requestParameters.exclusionsLicenses) {
            queryParameters['Exclusions.Licenses'] = requestParameters.exclusionsLicenses;
        }

        if (requestParameters.exclusionsWorkExperiences) {
            queryParameters['Exclusions.WorkExperiences'] = requestParameters.exclusionsWorkExperiences;
        }

        if (requestParameters.exclusionsEducations) {
            queryParameters['Exclusions.Educations'] = requestParameters.exclusionsEducations;
        }

        if (requestParameters.exclusionsCourses) {
            queryParameters['Exclusions.Courses'] = requestParameters.exclusionsCourses;
        }

        if (requestParameters.exclusionsVolunteerWork) {
            queryParameters['Exclusions.VolunteerWork'] = requestParameters.exclusionsVolunteerWork;
        }

        if (requestParameters.exclusionsJobTypes) {
            queryParameters['Exclusions.JobTypes'] = requestParameters.exclusionsJobTypes;
        }

        if (requestParameters.exclusionsJobGoals) {
            queryParameters['Exclusions.JobGoals'] = requestParameters.exclusionsJobGoals;
        }

        if (requestParameters.exclusionsJobFunctions) {
            queryParameters['Exclusions.JobFunctions'] = requestParameters.exclusionsJobFunctions;
        }

        if (requestParameters.useMotivationalTexts !== undefined) {
            queryParameters['UseMotivationalTexts'] = requestParameters.useMotivationalTexts;
        }

        if (requestParameters.motivationalHeadline !== undefined) {
            queryParameters['MotivationalHeadline'] = requestParameters.motivationalHeadline;
        }

        if (requestParameters.motivationalText !== undefined) {
            queryParameters['MotivationalText'] = requestParameters.motivationalText;
        }

        if (requestParameters.pdf !== undefined) {
            queryParameters['pdf'] = requestParameters.pdf;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/SaveCVToDocuments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentResponseBaseFromJSON(jsonValue));
    }

    /**
     */
    async saveCVToDocuments(requestParameters: SaveCVToDocumentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponseBase> {
        const response = await this.saveCVToDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveCoverLetterToDocumentsRaw(requestParameters: SaveCoverLetterToDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponseBase>> {
        const queryParameters: any = {};

        if (requestParameters.langCode !== undefined) {
            queryParameters['langCode'] = requestParameters.langCode;
        }

        if (requestParameters.mediaId !== undefined) {
            queryParameters['mediaId'] = requestParameters.mediaId;
        }

        if (requestParameters.colorNodeId !== undefined) {
            queryParameters['colorNodeId'] = requestParameters.colorNodeId;
        }

        if (requestParameters.exampleName !== undefined) {
            queryParameters['exampleName'] = requestParameters.exampleName;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/SaveCoverLetterToDocuments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentResponseBaseFromJSON(jsonValue));
    }

    /**
     */
    async saveCoverLetterToDocuments(requestParameters: SaveCoverLetterToDocumentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponseBase> {
        const response = await this.saveCoverLetterToDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveMotivationalTextRaw(requestParameters: SaveMotivationalTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/SaveMotivationalText`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async saveMotivationalText(requestParameters: SaveMotivationalTextRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveMotivationalTextRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setPublicRaw(requestParameters: SetPublicRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.documentId !== undefined) {
            queryParameters['documentId'] = requestParameters.documentId;
        }

        if (requestParameters.documentType !== undefined) {
            queryParameters['documentType'] = requestParameters.documentType;
        }

        if (requestParameters.programmeId !== undefined) {
            queryParameters['programmeId'] = requestParameters.programmeId;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/SetPublic`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async setPublic(requestParameters: SetPublicRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.setPublicRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateFileDataRaw(requestParameters: UpdateFileDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/UpdateFileData`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateFileData(requestParameters: UpdateFileDataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponse> {
        const response = await this.updateFileDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponseBase>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/Upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentResponseBaseFromJSON(jsonValue));
    }

    /**
     */
    async upload(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponseBase> {
        const response = await this.uploadRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadAssignmentResponseRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponseBase>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/UploadAssignmentResponse`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentResponseBaseFromJSON(jsonValue));
    }

    /**
     */
    async uploadAssignmentResponse(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponseBase> {
        const response = await this.uploadAssignmentResponseRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadDocumentsRaw(requestParameters: UploadDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.contentType !== undefined) {
            queryParameters['contentType'] = requestParameters.contentType;
        }

        if (requestParameters.fileName !== undefined) {
            queryParameters['fileName'] = requestParameters.fileName;
        }

        if (requestParameters.documentType !== undefined) {
            queryParameters['documentType'] = requestParameters.documentType;
        }

        if (requestParameters.uploadTypes !== undefined) {
            queryParameters['uploadTypes'] = requestParameters.uploadTypes;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/DocumentApi/UploadDocuments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async uploadDocuments(requestParameters: UploadDocumentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.uploadDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
